import React from "react";
import { EmployeeClassificationsAttributeContainer } from "../../containers";

const EmployeeClassificationsAttribute = (props) => {
  return <EmployeeClassificationsAttributeContainer {...props} />;
};

export default EmployeeClassificationsAttribute;
